import React from 'react'
import { Modal, Table, Tag } from 'antd'
import PropTypes from 'prop-types'
import { useQuery } from '@tanstack/react-query'
import { getNotificationLog } from 'services/documents/documentsServices'
import { errorMessage } from 'services/messager'

const CHANNEL_LABELS = {
	slack: 'Slack',
	email: 'E-mail',
}

const TYPE_LABELS = {
	vencimento_30: 'Vencimento em 30 dias',
	vencimento_15: 'Vencimento em 15 dias',
	assinatura_pendente: 'Assinatura pendente',
	status_periodico: 'Atualização periódica',
}

const columns = [
	{
		title: 'Canal',
		dataIndex: 'channel',
		key: 'channel',
		render: (value) => CHANNEL_LABELS[value] || value,
	},
	{
		title: 'Tipo',
		dataIndex: 'notification_type',
		key: 'notification_type',
		render: (value) => TYPE_LABELS[value] || value,
	},
	{
		title: 'Destinatário',
		dataIndex: 'recipient_email',
		key: 'recipient_email',
		render: (value) => value || '-',
	},
	{
		title: 'Status',
		dataIndex: 'success',
		key: 'success',
		render: (value) =>
			value ? <Tag color="green">Enviado</Tag> : <Tag color="red">Falhou</Tag>,
	},
	{
		title: 'Data',
		dataIndex: 'sent_at',
		key: 'sent_at',
		render: (value) => (value ? new Date(value).toLocaleString('pt-BR') : '-'),
	},
]

const fetchNotificationLog = async (documentId) => {
	try {
		return await getNotificationLog(documentId)
	} catch (error) {
		errorMessage({ content: 'Erro ao obter notificações enviadas' })
		return []
	}
}

const NotificationLogModal = ({ showModal, handleCancel, documentId }) => {
	const { data: notifications, isLoading } = useQuery({
		queryKey: ['notification-log', documentId],
		queryFn: () => fetchNotificationLog(documentId),
		enabled: showModal,
	})

	return (
		<Modal
			open={showModal}
			onCancel={handleCancel}
			title="Notificações de Vencimento Enviadas"
			destroyOnClose
			width={900}
			footer={null}>
			<Table
				columns={columns}
				dataSource={notifications || []}
				loading={isLoading}
				rowKey="id"
				pagination={{ pageSize: 10 }}
			/>
		</Modal>
	)
}

NotificationLogModal.propTypes = {
	showModal: PropTypes.bool,
	handleCancel: PropTypes.func.isRequired,
	documentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
		.isRequired,
}

export default NotificationLogModal
